export default "__VITE_ASSET__0sFyFdXc__"